import beneficiaryClause from 'src/circuits/transmission-circuit/beneficiary-clause-page/locales/index'
import barePropertyDonations from 'src/circuits/transmission-circuit/bare-property-page/locales/index'
import couple from 'src/circuits/transmission-circuit/couple-protection-page/locales/index'
import banners from './banners'
import cards from './cards'
import common from './common'
import dmpLike from './dmp-like'
import donationDetails from './donation-details'
import donationSummary from './donation-summary'
import indicators from './indicators'
import levers from './levers'
import lifeInsurance from './life-insurance'
import navigation from './navigation'
import shared from './shared'
import synthesisLongTerm from './synthesis-long-term'
import synthesisPage from './synthesis-page'
import userSimulation from './user-simulation'
import userSituation from './user-situation'

export default {
  barePropertyDonations,
  beneficiaryClause,
  common,
  couple,
  banners,
  cards,
  dmpLike,
  donationDetails,
  donationSummary,
  indicators,
  levers,
  lifeInsurance,
  navigation,
  shared,
  synthesisLongTerm,
  synthesisPage,
  userSimulation,
  userSituation,
}
